import { useMemo } from "react";
import { formatClass } from "../../../utils/formatters";

export const useFilteredGoals = (goalData = [], filterableColumns, selectedFilters) => {
  return useMemo(() => {
    const visibleFilters = filterableColumns.filter(({ visible, dataKey }) => visible && dataKey);

    if (!goalData || goalData.length === 0) return [];
    return goalData.filter((goal) => {
      return visibleFilters.every(({ key, dataKey }) => {
        const selected = selectedFilters[key];
        if (!selected || selected.length === 0) return false;

        const goalValue = goal[dataKey];

        if (key === "display") {
          return selected.some((displayVal) => {
            return goalValue === (displayVal.toLowerCase() === "active");
          });
        }

        return selected.some((filterVal) => formatClass(goalValue) === formatClass(filterVal));
      });
    });
  }, [goalData, filterableColumns, selectedFilters]);
};
